import React from 'react';

function ResultsPanel({ detections, imageInfo }) {
  if (!detections || detections.length === 0) {
    return null;
  }

  return (
    <div className="results-panel">
      <h2>Detection Results ({detections.length} area{detections.length > 1 ? 's' : ''} found)</h2>

      {imageInfo && (
        <div className="detection-card">
          <div className="detection-header">
            <span className="detection-title">Image Info</span>
          </div>
          <div className="coords-grid">
            <div className="coord-group">
              <h4>Image</h4>
              <div className="coord-values">
                <div><span>Filename:</span> {imageInfo.filename}</div>
                <div><span>Size:</span> {imageInfo.width} x {imageInfo.height} px</div>
              </div>
            </div>
            {imageInfo.physical_width_cm && imageInfo.physical_height_cm && (
              <div className="coord-group physical-size">
                <h4>Product Physical Size (Predicted)</h4>
                <div className="coord-values">
                  <div><span>Width:</span> {imageInfo.physical_width_cm.toFixed(1)} cm</div>
                  <div><span>Height:</span> {imageInfo.physical_height_cm.toFixed(1)} cm</div>
                </div>
                <h4 style={{marginTop: '0.5rem'}}>PPCM (Pixels Per CM)</h4>
                <div className="coord-values">
                  <div><span>PPCM X:</span> {imageInfo.ppcm_x?.toFixed(2)}</div>
                  <div><span>PPCM Y:</span> {imageInfo.ppcm_y?.toFixed(2)}</div>
                  <div><span>PPCM Avg:</span> <strong>{imageInfo.ppcm_avg?.toFixed(2)}</strong></div>
                  <div><span>Coherence:</span> <strong>{imageInfo.ppcm_coherence?.toFixed(0)}%</strong></div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {detections.map((detection, index) => (
        <div key={index} className="detection-card">
          <div className="detection-header">
            <span className="detection-title">Area {index + 1}</span>
            <span className="confidence-badge">
              {(detection.confidence * 100).toFixed(1)}% confidence
            </span>
          </div>

          <div className="coords-grid">
            {/* Coordinate Pixel (origine top-left) */}
            <div className="coord-group">
              <h4>Pixels (Top-Left Origin)</h4>
              <div className="coord-values">
                <div><span>x:</span> {detection.bbox_pixels.x.toFixed(1)}</div>
                <div><span>y:</span> {detection.bbox_pixels.y.toFixed(1)}</div>
                <div><span>width:</span> {detection.bbox_pixels.width.toFixed(1)}</div>
                <div><span>height:</span> {detection.bbox_pixels.height.toFixed(1)}</div>
              </div>
            </div>

            {/* Coordinate Normalizzate (origine top-left) */}
            <div className="coord-group">
              <h4>Normalized (Top-Left Origin)</h4>
              <div className="coord-values">
                <div><span>x:</span> {detection.bbox_normalized.x.toFixed(4)}</div>
                <div><span>y:</span> {detection.bbox_normalized.y.toFixed(4)}</div>
                <div><span>width:</span> {detection.bbox_normalized.width.toFixed(4)}</div>
                <div><span>height:</span> {detection.bbox_normalized.height.toFixed(4)}</div>
              </div>
            </div>

            {/* Coordinate Pixel (origine centro) */}
            <div className="coord-group">
              <h4>Pixels (Center Origin)</h4>
              <div className="coord-values">
                <div><span>x:</span> {detection.bbox_centered_pixels.x.toFixed(1)}</div>
                <div><span>y:</span> {detection.bbox_centered_pixels.y.toFixed(1)}</div>
                <div><span>width:</span> {detection.bbox_centered_pixels.width.toFixed(1)}</div>
                <div><span>height:</span> {detection.bbox_centered_pixels.height.toFixed(1)}</div>
              </div>
            </div>

            {/* Coordinate Normalizzate (origine centro) */}
            <div className="coord-group">
              <h4>Normalized (Center Origin)</h4>
              <div className="coord-values">
                <div><span>x:</span> {detection.bbox_centered_normalized.x.toFixed(4)}</div>
                <div><span>y:</span> {detection.bbox_centered_normalized.y.toFixed(4)}</div>
                <div><span>width:</span> {detection.bbox_centered_normalized.width.toFixed(4)}</div>
                <div><span>height:</span> {detection.bbox_centered_normalized.height.toFixed(4)}</div>
              </div>
            </div>

            {/* Dimensioni Fisiche dell'area di stampa (con PPCM medio - consigliato) */}
            {(detection.physical_width_cm_avg || detection.physical_height_cm_avg) && (
              <div className="coord-group physical-size">
                <h4>Print Area Size (PPCM Avg) ⭐</h4>
                <div className="coord-values">
                  <div><span>Width:</span> <strong>{detection.physical_width_cm_avg?.toFixed(2)} cm</strong></div>
                  <div><span>Height:</span> <strong>{detection.physical_height_cm_avg?.toFixed(2)} cm</strong></div>
                  <div><span>Area:</span> <strong>{(detection.physical_width_cm_avg * detection.physical_height_cm_avg).toFixed(1)} cm²</strong></div>
                </div>
              </div>
            )}
            {/* Dimensioni Fisiche con PPCM per asse (per confronto) */}
            {(detection.physical_width_cm || detection.physical_height_cm) && (
              <div className="coord-group">
                <h4>Print Area Size (PPCM per axis)</h4>
                <div className="coord-values">
                  <div><span>Width:</span> {detection.physical_width_cm?.toFixed(2)} cm</div>
                  <div><span>Height:</span> {detection.physical_height_cm?.toFixed(2)} cm</div>
                  <div><span>Area:</span> {(detection.physical_width_cm * detection.physical_height_cm).toFixed(1)} cm²</div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ResultsPanel;
